module.exports = __webpack_public_path__ + "img/campus-kprc25.83ed4fd3.svg";